import actionTypes from '../constants/action-types';

const metaTranslations = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.SET_META_TRANSLATIONS:
      return action.payload.translations;
    default:
      return state;
  }
};

export default metaTranslations;
